import * as React from 'react';
import {RegulatoryDocumentsContext} from '.';

export const useRegulatoryDocumentsContext = () =>
	React.useContext(RegulatoryDocumentsContext);
